import '../../styles/pages/policy.scss';